import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormField} from 'hateoas-navigator';
import {FormGroup} from '@angular/forms';
import {HalDocumentService} from 'hateoas-navigator';
import {VersionedResourceAdapter} from 'hateoas-navigator';
import {ResourceLink} from 'hateoas-navigator';
import {FormControlFactory} from 'hateoas-navigator';
import {PropertyDescriptor} from 'hateoas-navigator';
import {SubFormField} from 'hateoas-navigator';
import {Subscription} from 'rxjs/Rx';

@Component({
  selector: 'app-new-resource',
  template: `<div class="mat-elevation-z4 cmp-border">
  <h1 class="mat-display-1">{{title}}</h1>
  <form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-form-group [fields]="fields" [formGroup]="form"></app-form-group>

    <div class="cmp-form-buttons">
      <a mat-raised-button routerLink="..">Cancel</a>
      <button mat-raised-button color="primary" type="submit" [disabled]="!form.valid">Save</button>
    </div>
  </form>
</div>
`,
  styles: [`form{min-width:300px;max-width:600px;margin:auto}.cmp-form-buttons{margin-top:40px}.cmp-border{padding:50px}`]
})
export class ResourceFormComponent implements OnInit {
  fields: FormField[];
  title: string;
  form: FormGroup;
  private newItem: boolean;
  private version: string;

  constructor(private route: ActivatedRoute, private router: Router, private halDocumentService: HalDocumentService) {
  }

  ngOnInit() {
    this.route.data.subscribe((data: { resourceObject: VersionedResourceAdapter, resourceDescriptor: PropertyDescriptor }) => {
      const resourceObject = data.resourceObject;
      const descriptor = resourceObject ? resourceObject.getDescriptor() : data.resourceDescriptor;
      this.fields = (descriptor.toFormFieldBuilder().build() as SubFormField).getSubFields();
      this.title = descriptor.getTitle();
      const controls = new FormControlFactory(resourceObject).getControls(this.fields);
      this.form = new FormGroup(controls);
      this.newItem = !data.resourceObject;
      if (!this.newItem) {
        this.version = data.resourceObject.getVersion();
      }
    });
  }

  onSubmit(): Subscription {
    const submitFunction = this.newItem ?
      (resourceName, object) => this.halDocumentService.create(resourceName, object) :
      (resourceName, object) => this.halDocumentService.update(resourceName, this.route.snapshot.url[1].path, object, this.version);
    return submitFunction(this.route.snapshot.url[0].path, this.form.value).subscribe((item: VersionedResourceAdapter) => {
      return this.router.navigateByUrl(ResourceLink.fromResourceObject(item.resourceObject, undefined).getRelativeUri());
    });
  }
}
